<template>
  <div>
    <div>
      <img v-if="estidata.nation === 'i'"
        class="img-fluid mainimage"
        src="/static/images/top/import_list.png"/>
      <img v-else-if="estidata.nation === 'l'"
        class="img-fluid mainimage"
        src="/static/images/top/local_list.png"/>
    </div>
    <div>
      <mdb-container>
        <div>
          <div class="topstyle d-none d-sm-block">
            <mdb-row class="maintitlestyle border-bottom border-dark">
              <span v-if="estidata.nation === 'i'"
                class="maintitleborderimport">
                  수입차 가격표
               </span>
              <span v-else-if="estidata.nation === 'l'"
                class="maintitleborderlocal">
                  국산차 가격표
               </span>
            </mdb-row>
            <mdb-row class="cartitlestyle">
              {{estidata.name}}
            </mdb-row>
            <mdb-row >
              <mdb-col class="col-sm-6">
                <div class="subjectmargin">
                  <span class="col-xs-5 subject">
                    가격
                  </span>
                  <span class="col-xs-7 subjectdata">
                    {{estidata.price}}만원
                  </span>
                </div>
                <div class="subjectmargin">
                  <span class="col-xs-5 subjectrate">
                    금리
                  </span>
                  <span class="col-xs-7 subjectdatarate">
                    {{estidata.interestRate}}%
                  </span>
                </div>
                <div class="subjectmargin">
                  <span class="col-xs-5 subjectauto">오토리스</span>
                  <span class="col-xs-7 subjectdataprice">
                    월&nbsp;&nbsp;
                    {{estidata.monthlyPrice}}만원
                  </span>
                </div>
              </mdb-col>
              <mdb-col class="colimg">
                <img class="carimage"
                  :src="estidata.srcImg">
              </mdb-col>
            </mdb-row>
          </div>
          <div class="topstylemobile d-block d-sm-none">
            <mdb-row class="maintitlestyle border-bottom border-dark">
              <span v-if="estidata.nation === 'i'"
                class="maintitleborderimport">
                  수입차 가격표
               </span>
              <span v-else-if="estidata.nation === 'l'"
                class="maintitleborderlocal">
                  국산차 가격표
               </span>
            </mdb-row>
            <mdb-row class="cartitlestyle">
              {{estidata.name}}
            </mdb-row>
            <mdb-row>
              <mdb-col class="colimgmobile">
                <img class="carimagemobile"
                  :src="estidata.srcImg">
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col class="col-sm-6">
                <div class="subjectmarginmobile">
                  <span class="col-xs-5 subject">
                    가격
                  </span>
                  <span class="col-xs-7 subjectdata">
                    {{estidata.price}}만원
                  </span>
                </div>
                <div class="subjectmarginmobile">
                  <span class="col-xs-5 subjectrate">
                    금리
                  </span>
                  <span class="col-xs-7 subjectdatarate">
                    {{estidata.interestRate}}%
                  </span>
                </div>
                <div class="subjectmarginmobile">
                  <span class="col-xs-5 subjectauto">오토리스</span>
                  <span class="col-xs-7 subjectdataprice">
                    월&nbsp;&nbsp;
                    {{ estidata.monthlyPrice }}만원
                  </span>
                </div>
              </mdb-col>
            </mdb-row>
          </div>
          <mdb-row class="smsrow">
            <requestsms />
          </mdb-row>
          <mdb-card class="wcard" wide>
            <mdb-view class="wcard" hover cascade>
              <a class="wcard" href="#!">
                <mdb-card-image
                  class="img-fluid center wcard"
                  :src="estidata.srcEstimate" alt="Card image cap" />
                <mdb-mask flex-center waves overlay="white-slight" />
              </a>
            </mdb-view>
            <mdb-card-body class="text-center pb-0 wcard" cascade>
              <mdb-card-title><strong>할부보다 저렴한 리스! 어떻게 가능할까?</strong></mdb-card-title>
              <img class="quotationbottom" src = "/static/images/quotation/quotationbottom.png" />
              <mdb-card-footer class="text-muted mt-6 wcard">
                *개인의신용도에따라상이할수있습니다.
              </mdb-card-footer>
            </mdb-card-body>
          </mdb-card>
        </div>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import requestsms from '@/components/RequestSms.vue';
import { carEstimate } from '../api';

export default {
  data() {
    return {
      panes: [
        {
          title: '진짜 노마진? 최저금리  인가요?',
          content: '<img class="img-fluid center" :src="estidata.srcEstimate" />',
        },
      ],
      bid: 0,
      estidata: null,
    };
  },
  created() {
    this.fetchData();
  },
  components: {
    requestsms,
  },
  methods: {
    fetchData() {
      carEstimate.fetch(this.$route.params.bid)
        .then((data) => {
          this.estidata = data.data;
        })
        .finally(() => {
        });
    },
  },
};
</script>

<style scoped>
.smsrow {
  max-width: 100%;
  height: auto;
  margin: auto auto;
}

.wcard {
  max-width: 746px;
  margin: auto auto;
  z-index: -9999999999;
}

.view .mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-attachment: inherit;
}

.mainimage {
  height: 100%;
  width: 100%;
  margin-top: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
}

.topstyle{
  height: 350px;
}

.topstylemobile{
  height: 470px;
}

.colimg {
  max-width: 360px;
  max-height: 180px;
  align-items: center;
  margin: 0 0px;
}

.colimgmobile {
  max-width: 360px;
  max-height: 180px;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

.maintitlestyle {
  margin-top: 15px;
  color:#000;
  font-size: 22px;
  font-weight: bold;
  max-width: 1100px;
}

.maintitleborderimport {
  border-bottom: 4px solid #ffba00;
  font-weight: 800;
}

.maintitleborderlocal {
  border-bottom: 4px solid black;
}

.cartitlestyle {
  padding-left: 40px;
  margin-top: 12px;
  margin-bottom: 15px;
  font-size: 26px;
  font-weight: bold;
}

.subjectmargin {
  margin-top: 15px;
  margin-bottom: 25px;
  margin-left: 0px;
}

.subjectmarginmobile {
  margin-top: 15px;
  margin-bottom: 25px;
  margin-left: 15px;
}

.subject {
  float: left;
  font-size: 17px;
  font-weight: bold;
  font-family: "Proxima Nova";
  padding-left: 0px;
  align-items: left;
  margin: 0 0px;
}

.subjectrate {
  float: left;
  font-size: 17px;
  font-weight: bold;
  font-family: "Nanum Gothic", Roboto, sans-serif;
  padding-left: 0px;
  align-items: left;
  margin: 0 0px;
}

.subjectauto {
  float: left;
  font-size: 17px;
  font-weight: bold;
  font-family: "Nanum Gothic", Roboto, sans-serif;
  padding-left: 0px;
  align-items: left;
  margin: 0 0px;
}

.subjectdata {
  text-align: left;
  font-weight: bold;
  font-size: 17px;
  font-family: "Nanum Gothic", Roboto, sans-serif;
  padding-left: 20px;
  margin-left: 0px;
}

.subjectdatarate {
  text-align: left;
  font-weight: bold;
  font-size: 17px;
  font-family: "Nanum Gothic", Roboto, sans-serif;
  padding-left: 10px;
  margin-left: 0px;
  font-weight: 600;
}

.subjectdataprice {
  color: rgb(230, 10, 10);
  text-align: left;
  font-weight: bold;
  margin-left: 0px;
  padding-left: 0px;
  font-size: 23px;
  font-family: "Nanum Gothic", Roboto, sans-serif;
  padding: 0px;
}

.subjectdatapricemonth {
  text-align: left;
  font-weight: bold;
  font-size: 25px;
  font-family: "Nanum Gothic", Roboto, sans-serif;
  padding-left: 29px;
}

.carimage {
  width: 100%;
  height: 100%;
  margin-top: 0px;
  object-fit: fill;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}

.carimagemobile {
  width: 100%;
  height: 100%;
  margin-top: 0px;
  object-fit: fill;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}

.col-sm-9 {
  margin-left: 20% !important;
}

.btn-info:active {
  color: #fff;
  background-color: #ffba00 !important;
  border-color: #ffba00 !important;
}
.btn-info:hover {
  color: #fff;
  background-color: #ffba00 !important;
  border-color: #ffba00 !important;
}
.estimateimg{
  clear: both;
  width: 100%;
  height: 100%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}
.accordion:hover .accordion-item:hover .accordion-item-content,
.accordion .accordion-item--default .accordion-item-content {
  height: 6em;
}

.accordion-item-content,
.accordion:hover .accordion-item-content {
  height: 0;
  overflow: hidden;
  transition: height .25s;
}

/* Aesthetic */
body {
  background: #222;
}

.accordion {
  padding: 0;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  font-family: 'Nanum Square','Nanum Gothic', 'Noto Sans KR',
    'Malgun Gothic', 'Roboto', Arial, Dotum, Gulim, Verdana, Tahoma;
}

.accordion .accordion-item {
  background-image: linear-gradient(90deg, #eee, #f5f5f5, #eee);
  border-bottom: 1px solid #666;
  padding: 1em;
  color: #eee;
  height: 100%;
}
.accordion .accordion-item:hover {
  background-image: linear-gradient(90deg, #eee, #f5f5f5, #eee);
  border-bottom: 1px solid #666;
  padding: 1em;
  color: #eee;
  height: 100%;
}

.accordion h1 {
  margin: 0;
}
.accordion h1:hover {
  margin: 0;
  height: 100%;
}
.accordion .accordion-item:nth-child(1) {
  background-color: black;
  background-image: linear-gradient(-90deg, hsl(0, 0%, 0%), hsl(0, 0%, 0%) 2em, hsl(0, 0%, 0%));
  max-width: 100%;
  height: 100%;
}

.accordion-item-content:hover {
  height: 100% !important;
  overflow: hidden;
  -webkit-transition: height .25s;
  transition: height .25s;
}
.accordion:hover {
  height: 100% !important;
}
.quotationbottom {
  max-width: 100%;
  height: auto;
  align-content: center;
  margin: auto auto;
}
</style>
